<template>
  <div class="col-12">
    <b-card>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <div class="table-responsive" v-if="!isLoading">
        <table v-if="capacity.length > 0" class="table">
          <thead>
            <tr>
              <th>تاریخ مصاحبه</th>
              <th v-for="(room, i) in rooms" :key="i">
                اتاق{{ room.room_number
                }}{{ room.room_name ? `(${room.room_name})` : `` }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(items, i) in capacity" :key="i">
              <td>{{ items.date.jalali }}</td>
              <th v-for="(item, y) in items.data" :key="y">
                <div v-if="item && item.audience_count">
                  تعداد متقاضی :
                  <span
                    :class="
                      item && item.audience_count
                        ? `text-success`
                        : `text-danger`
                    "
                    >{{
                      item && item.audience_count
                        ? item.audience_count
                        : `ندارد`
                    }}</span
                  >
                </div>
                <div v-if="item && item.master_count">
                  تعداد استاد مصاحبه :
                  <span
                    :class="
                      item && item.master_count ? `text-success` : `text-danger`
                    "
                    >{{
                      item && item.master_count ? item.master_count : `ندارد`
                    }}</span
                  >
                </div>
              </th>
            </tr>
          </tbody>
        </table>
        <div v-if="capacity.length == 0">
          {{ $lang.dataNotExist }}
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      items: [],
      isLoading: false,
      room: [],
      capacity: [],
    };
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.interview.interview_location_plan_id.replace(
            "{0}",
            this.id
          );
        const response = await this.$httpService.get(url);
        let data = response.data.data;
        this.rooms = data.rooms;
        this.capacity = data.capacity.map((x) => {
          let date = null;
          let count = null;
          x.map((y, i) => {
            if (i == 0) {
              (date = y.date), (count = x.length);
            }
          });

          return {
            date: date,
            count: count,
            data: [...x],
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

